<template>
  <v-dialog
    max-width="800"
    :value="value"
    persistent
    :fullscreen="$vuetify.breakpoint.smAndDown"
    @keydown.esc="close(selectedItem)"
  >
    <v-card tile v-if="value">
      <v-app-bar dark flat color="primary">
        <v-btn icon dark @click="close(selectedItem)">
          <v-icon>close</v-icon>
        </v-btn>
        <span class="title">{{
          originalSelectedItem.name
            ? resx.labels.updateContractorType
            : resx.labels.newContractorType
        }}</span>
      </v-app-bar>
      <form @submit.prevent="save()" novalidate>
        <v-card-text>
          <v-container grid-list-xl>
            <v-row wrap>
              <v-col cols="12" md="6">
                <v-text-field
                  data-vv-name="name"
                  :data-vv-as="resx.labels.name"
                  :label="resx.labels.name"
                  :error-messages="errors.collect('name')"
                  v-model="selectedItem.name"
                  v-validate="'required'"
                  required
                />
              </v-col>
              <v-col cols="12" md="6">
                <comments-component
                  v-model="selectedItem.comments"
                  mode="edit"
                  :label="resx.labels.comments"
                  @input="selectedItem.comments = $event"
                />
              </v-col>
              <v-col cols="12" class="input-comment">
                <select-obligations
                  v-model="selectedItem.obligations"
                  :obligations="obligations"
                ></select-obligations>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close(selectedItem)">{{ resx.labels.cancel }}</v-btn>
          <v-btn
            class="primary"
            type="submit"
            :disabled="
              !isValidForm ||
                !selectedItem.obligations ||
                selectedItem.obligations.length == 0
            "
            >{{ resx.labels.ok }}</v-btn
          >
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import contractorTypeService from "@/services/ContractorTypeService";
import { sprintf } from "sprintf-js";
import commentsComponent from "@/components/common/comments.vue";
import selectObligations from "@/components/common/select-obligations.vue";

export default {
  name: "edit-contractor-type",
  async mounted() {
    this.obligations = await contractorTypeService.getObligations();
  },
  components: {
    commentsComponent,
    selectObligations
  },
  data() {
    return {
      menu: false,
      obligations: [],
      dueDateType: [],
      datePicked: null,
      selectedItem: null,
      originalSelectedItem: null,
      loadingOblig: false,
      searchOblig: ""
    };
  },
  methods: {
    async save() {
      let result = null;
      let payload = Object.assign({}, this.selectedItem);
      if (!this.selectedItem._id) {
        result = await contractorTypeService.create(payload);
        this.$emit("save", { isNew: true, item: result });
      } else {
        result = await contractorTypeService.edit(payload);
        this.$emit("save", { isNew: false, item: result });
      }
    },
    async close(contractorType) {
      if (JSON.stringify(this.originalSelectedItem) != JSON.stringify(this.selectedItem)) {
        await this.botConfirmDialog({
          title: `${
          this.resx.labels.edit
          } ${this.resx.labels.contractorType.toLowerCase()}`,
          content: sprintf(
          this.resx.messages.noSavedChanges,
          contractorType.name
          )
        });
        this.$emit("close");
      } else {
        this.$emit("close");
      }
    },
    queryObligations(v) {
      this.loadingOblig = true;
      setTimeout(() => {
        this.items = this.obligations.filter(e => {
          return (
            (e.name || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1
          );
        });
        this.loadingOblig = false;
      }, 500);
    }
  },
  props: ["value"],
  watch: {
    searchOblig(val) {
      val && this.queryObligations(val);
    },
    value(val) {
      this.selectedItem =
        val && val.selectedItem ? Object.assign({}, val.selectedItem) : {};
      this.originalSelectedItem = Object.assign({}, this.selectedItem);
    }
  }
};
</script>

<style>
.chip .chip__content {
  height: 20px;
}
</style>
